module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "goods"
  }, [_c('ul', {
    directives: [{
      name: "lun",
      rawName: "v-lun"
    }],
    staticClass: "clearfix"
  }, _vm._l((_vm.carousel), function(g, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": g
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info_a"
  }, [_vm._v("\n            " + _vm._s(_vm.gooding.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "info_b"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v(_vm._s(_vm.gooding.price))])]), _vm._v(" "), _c('div', {
    staticClass: "info_c"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v("销量" + _vm._s(_vm.gooding.id))]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.gooding.cfav))]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v("8小时发货")]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.gooding.city))])]), _vm._v(" "), _c('div', {
    staticClass: "info_d"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "good",
    attrs: {
      "src": "https://s10.mogucdn.com/mlcdn/c45406/170711_701e7hcfi1j9fe76hgd560bj28d87_14x22.png",
      "alt": ""
    },
    on: {
      "click": _vm.openBottomSheet
    }
  })]), _vm._v(" "), _c('div', [_c('mu-bottom-sheet', {
    attrs: {
      "open": _vm.bottomSheet
    },
    on: {
      "close": _vm.closeBottomSheet
    }
  }, [_c('mu-list', {
    on: {
      "itemClick": _vm.closeBottomSheet
    }
  }, [_c('mu-list-item', {
    attrs: {
      "title": "超时赔付"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ccc"
  }, [_vm._v("您支付后会在预定时间内发出，若未按照约定发货，交易完成后可获得5/10元优惠券补贴")]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "全场包邮"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ccc"
  }, [_vm._v("所有商品均享受包邮，您不用承担任何发货运费")]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "退货补运费"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ccc"
  }, [_vm._v("您退货产生的运费会以5/10元现金形式返还到您美丽说的钱包中")]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "7天无忧退货"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ccc"
  }, [_vm._v("商品签收起7天内如不满意您可申请无理由退货，免除您的后顾之忧 ")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    attrs: {
      "open": _vm.bottomSheet
    },
    on: {
      "click": _vm.closeBottomSheet
    }
  }, [_vm._v("完成")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "tab_a"
  }, [_c('ul', {
    staticClass: "tab clearfix"
  }, [_c('li', {
    staticClass: "tab-item"
  }, [_c('span', {
    directives: [{
      name: "settop",
      rawName: "v-settop",
      value: ('panel_a'),
      expression: "'panel_a'"
    }]
  }, [_vm._v("图文详情")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('span', {
    directives: [{
      name: "settop",
      rawName: "v-settop",
      value: ('panel_b'),
      expression: "'panel_b'"
    }]
  }, [_vm._v("商品参数")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('span', {
    directives: [{
      name: "settop",
      rawName: "v-settop",
      value: ('panel_c'),
      expression: "'panel_c'"
    }]
  }, [_vm._v("评价()")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('span', {
    directives: [{
      name: "settop",
      rawName: "v-settop",
      value: ('panel_d'),
      expression: "'panel_d'"
    }]
  }, [_vm._v("热卖推荐")]), _vm._v(" "), _c('i')])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel_a"
  }, [_c('div', {
    staticClass: "prap"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.gooding.title))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "pics"
  }, [_c('dl', [_c('dd', {
    staticClass: "pic-list"
  }, _vm._l((_vm.detailImage), function(rute, index) {
    return _c('img', {
      key: index,
      staticClass: "fadeIn",
      attrs: {
        "src": rute
      }
    })
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel_c"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "does",
      rawName: "v-does",
      value: (_vm.cuss),
      expression: "cuss"
    }],
    staticClass: "rate-root"
  }, [_vm._v("暂无评价")]), _vm._v(" "), _c('div', {
    staticClass: "rate-list"
  }, [_c('div', {
    staticClass: "rate-user"
  }, [_c('span', {
    staticClass: "user-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.nows.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.nows.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "rate-cont"
  }, [_vm._v("\n                " + _vm._s(_vm.nows.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "rate-attr"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.nows.time))]), _vm._v(" "), _c('span', {
    staticClass: "sku"
  }, [_vm._v("颜色:" + _vm._s(_vm.nows.color) + " 尺码:【" + _vm._s(_vm.nows.size) + "】 ")])]), _vm._v(" "), _c('div', {
    staticClass: "rate-imgs"
  }, [_c('img', {
    attrs: {
      "src": _vm.nows.img,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel_d"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "list_ch clearfix"
  }, _vm._l((this.men), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#/detail"
      }
    }, [_c('img', {
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "li_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(item.price) + " "), _c('span', {
      staticClass: " collect"
    })])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_a"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.Cool()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("收藏")])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "footer_b"
  }, [_c('span', {
    staticClass: "buy-cart",
    on: {
      "click": _vm.openSheet
    }
  }, [_vm._v("加入购物车")]), _vm._v(" "), _c('span', {
    staticClass: "buy-now"
  }, [_vm._v("购买")])])]), _vm._v(" "), _c('mu-bottom-sheet', {
    attrs: {
      "open": _vm.Sheet
    },
    on: {
      "close": _vm.closeSheet
    }
  }, [_c('mu-list', {
    on: {
      "itemClick": _vm.Sheet
    }
  }, [_c('div', {
    staticClass: "car_a"
  }, [_c('div', {
    staticClass: "cart"
  }, [_c('img', {
    attrs: {
      "src": _vm.gooding.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_c('span', {
    staticClass: "show_a"
  }, [_vm._v(_vm._s(_vm.gooding.title))]), _vm._v(" "), _c('div', {
    staticClass: "show_b"
  }, [_c('span', {
    staticClass: "price_a"
  }, [_vm._v(_vm._s(_vm.gooding.price))]), _vm._v(" "), _c('span', {
    staticClass: "price_b"
  }, [_vm._v("库存\n                    "), _c('span', {
    staticClass: "qty"
  }, [_vm._v(_vm._s(_vm.gooding.buyCount))]), _vm._v(" 件")])]), _vm._v(" "), _c('span', {
    staticClass: "close"
  }, [_vm._v("╳")])])]), _vm._v(" "), _c('div', {
    staticClass: "scoll"
  }, [_c('div', {
    staticClass: "sku-list"
  }, [_c('div', {
    staticClass: "list_a"
  }, [_c('p', [_vm._v("颜色：")]), _vm._v(" "), _c('span', {
    staticClass: "yanse"
  }, [_vm._v("白色")])]), _vm._v(" "), _c('div', {
    staticClass: "list_b"
  }, [_c('p', [_vm._v("尺码：")]), _vm._v(" "), _c('span', {
    staticClass: "yanse"
  }, [_vm._v("均码")])])]), _vm._v(" "), _c('div', {
    staticClass: "sku-num"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量：")]), _vm._v(" "), _c('div', {
    staticClass: "counter"
  }, [_c('span', {
    staticClass: "counter_a"
  }, [_c('b', {
    staticClass: "counter_a_a",
    on: {
      "click": function($event) {
        _vm.del()
      }
    }
  }, [_vm._v("－")])]), _vm._v(" "), _c('em', {
    staticClass: "counter_a_b"
  }, [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('span', {
    staticClass: "counter_a"
  }, [_c('b', {
    staticClass: "counter_a_c",
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("＋")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "open": _vm.Sheet
    },
    on: {
      "click": _vm.closeSheet
    }
  }, [_c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ing"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "https://s10.mogucdn.com/p1/160607/upload_ie4tkmbtgqztomjqhezdambqgqyde_44x44.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("退货补运费")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://s10.mogucdn.com/p1/160607/upload_ie4tkmbtgqztomjqhezdambqgqyde_44x44.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("全国包邮")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://s10.mogucdn.com/p1/160607/upload_ie4tkmbtgqztomjqhezdambqgqyde_44x44.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("7天无理由退货")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-info"
  }, [_c('div', {
    staticClass: "fix"
  }, [_c('a', {
    staticClass: "fix_a",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "http://s3.mogucdn.com/p2/161111/hz75la_8f8kk1ff66365a77e520dckl0lb51_200x200.jpg_100x100.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix_b"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("美丽优选")]), _vm._v(" "), _c('span', {
    staticClass: "has",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("已收藏")]), _vm._v(" "), _c('span', {
    staticClass: "not"
  }, [_vm._v("+收藏")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sale"
  }, [_c('span', [_vm._v("2354772")]), _vm._v(" "), _c('br'), _vm._v("总销量\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "all"
  }, [_c('span', [_vm._v("41136")]), _vm._v(" "), _c('br'), _vm._v("全部宝贝\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "send"
  }), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("描述相符")]), _vm._v(" "), _c('em', [_vm._v("4.60")]), _vm._v(" "), _c('i', [_vm._v("高")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("价格合理")]), _vm._v(" "), _c('em', [_vm._v("4.59")]), _vm._v(" "), _c('i', [_vm._v("高")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("质量满意")]), _vm._v(" "), _c('em', [_vm._v("4.58")]), _vm._v(" "), _c('i', [_vm._v("高")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "goshop"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("进店逛逛")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "start"
  }, [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "end"
  }, [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel_b"
  }, [_c('div', {
    staticClass: "panel-head"
  }, [_c('span', [_vm._v("商品参数")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "size"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("尺码")]), _vm._v(" "), _c('td', [_vm._v("【M】")]), _vm._v(" "), _c('td', [_vm._v("【S】")]), _vm._v(" "), _c('td', [_vm._v("【L】")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("胸围")]), _vm._v(" "), _c('td', [_vm._v("87")]), _vm._v(" "), _c('td', [_vm._v("93")]), _vm._v(" "), _c('td', [_vm._v("91")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("腰围")]), _vm._v(" "), _c('td', [_vm._v("72")]), _vm._v(" "), _c('td', [_vm._v("68")]), _vm._v(" "), _c('td', [_vm._v("76")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("裙长")]), _vm._v(" "), _c('td', [_vm._v("89-95")]), _vm._v(" "), _c('td', [_vm._v("88-94")]), _vm._v(" "), _c('td', [_vm._v("90-96")])])])]), _vm._v(" "), _c('div', {
    staticClass: "size-image"
  }, [_c('img', {
    attrs: {
      "src": "http://s3.mogucdn.com/p2/170117/upload_5jebi0af8537id564g95ehj0g781k_1125x647.jpg_468x468.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://s3.mogucdn.com/p2/170118/upload_00e2357hd57g860f9khakh3a6bbbi_1125x915.png_468x468.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://s17.mogucdn.com/p2/170727/10000000_6i23472bhk0llea4hgikfbhdc00ii_1500x3018.jpg_468x468.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://s3.mogucdn.com/p2/170118/upload_55c7c64956bfbd75c3ib3j4ik029b_1125x509.png_468x468.jpg"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rate-head"
  }, [_c('a', {
    staticClass: "tit",
    attrs: {
      "href": ""
    }
  }, [_vm._v("购买评价\n                    "), _c('span', {
    staticClass: "more"
  }, [_vm._v("更多\n                       "), _c('i', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": "https://s10.mogucdn.com/mlcdn/c45406/170711_701e7hcfi1j9fe76hgd560bj28d87_14x22.png",
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mend"
  }, [_c('span', [_vm._v("热卖推荐")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../img/kefu.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("客服")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../img/dianpu.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("店铺")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("已收藏")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1aebfe04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1aebfe04","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/xdetail.vue
// module id = 242
// module chunks = 0